import request from '../../utils/request';

export default params => request('/request-records', { params });
